import { useQuery } from "react-query";

export const useProducts = () => {
  const { data, isLoading } = useQuery({
    queryKey: [`products`],
    queryFn: async () => {
      try {
        const response = await fetch(
          `${import.meta.env.VITE_REACT_APP_API_URL}/api/products`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      } catch (error) {
        console.log(error);
      }
    },
  });

  return {
    data,
    isLoading,
  };
};

export const useProduct = (id) => {
  const { data, isLoading } = useQuery({
    queryKey: [`products` + id],
    queryFn: async () => {
      try {
        const response = await fetch(
          `${import.meta.env.VITE_REACT_APP_API_URL}/api/products/${id}`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      } catch (error) {
        console.log(error);
      }
    },
  });

  return {
    data,
    isLoading,
  };
};
